<template>
    <form @submit.prevent="onLoginSubmit">
        <div :style="{ maxWidth: '40rem' }" class="grid">
            <div class="col-12 py-0 sm:col-6 flex flex-column sm:w-20rem">
                <label for="email">E-Mail</label>
                <TableInput id="login-email" :error-message="errors.email" :value="email" class="w-full"
                            name="login-email" placeholder="" type="email" @update:modelValue="(val) => email = val"/>
            </div>
            <div class="col-12 pt-0 sm:col-6 flex flex-column sm:w-20rem">
                <label for="password">Passwort</label>
                <TableInput id="login-pw" :error-message="errors.pw" :value="pw"
                            class="w-full" name="login-pw" placeholder=""
                            type="password" @update:modelValue="(val) => pw = val"/>
            </div>
            <div class="col-12 pt-0">
                <TableButton label="Einloggen" type="submit" :loading="loading"/>
            </div>
        </div>
    </form>
</template>

<script lang="ts" setup>
import TableInput from "@/components/TableInput.vue";
import TableButton from "@/components/TableButton.vue";
import {useForm} from "vee-validate";
import {object, string} from "yup";
import validation_messages from '../validation_messages.json';
import {useUserStore} from "@/stores/UserStore";
import type {login} from "@/types/types";
import {ref} from "vue";

const userStore = useUserStore();
const loginSchema = object({
    email: string().required(validation_messages.email).email(validation_messages.email_invalid),
    pw: string().required(validation_messages.pw),
});

const {defineField, errors, handleSubmit} = useForm({
    validationSchema: loginSchema,
});

const [email] = defineField('email');
const [pw] = defineField('pw');
const emit = defineEmits<{ (e: 'loggedIn'): void }>();
const loading = ref(false);

const onLoginSubmit = handleSubmit(async (values) => {
    loading.value = true;

    const response : {success: boolean, sessionHash : string} = await userStore.loginUser(values as login)
    if (response && response.success) {
      await userStore.getUserData();
      emit('loggedIn');
    }
      loading.value = false;
});

</script>

